// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "c871d6c";
